import { Switch } from '../../../components';
import { BlueResultBox } from '../components/BlueResultBox';
import { formatDanishDate } from '../../../components/DanishDateFormatter';

type ThermometerFeedbackProps = {
    pressureLevel: number;
    text?: string;
    setText?: (value: string) => void;
};

export function ThermometerFeedback({
    pressureLevel,
    text,
    setText,
}: ThermometerFeedbackProps) {
    return (
        <Switch
            value={pressureLevel}
            cases={{
                1: (
                    <BlueResultBox
                        date={formatDanishDate(new Date())}
                        number={pressureLevel}
                        heading="Du har det chill"
                        description={[
                            'Du lader til at være rolig og afslappet. Klap dig selv på skulderen. Du har fået det til at ske.',
                        ]}
                    />
                ),
                2: (
                    <BlueResultBox
                        date={formatDanishDate(new Date())}
                        number={pressureLevel}
                        heading="Du har det småvarmt"
                        description={[
                            'Du lader til at være i balance, men mærker lidt pres. Tænk på en du holder af. Forsøg at holde vedkommende i din opmærksomhed, og lad de gode følelser fylde.',
                        ]}
                    />
                ),
                3: (
                    <BlueResultBox
                        date={formatDanishDate(new Date())}
                        number={pressureLevel}
                        heading="Du har det lidt for varmt"
                        description={[
                            'Du lader til at mærke lidt pres, men det er stadig håndterbart. Tag et øjeblik og mærk efter: kan du gøre noget i dette øjeblik for at give mere overskud?',
                        ]}
                    />
                ),
                4: (
                    <BlueResultBox
                        date={formatDanishDate(new Date())}
                        number={pressureLevel}
                        heading="Du har det intenst varmt"
                        description={[
                            'Det lader til, at du føler dig presset og har brug for at komme ned i temperatur.',
                            'Prøv at lave en 4-7-8 åndedræt. Træk vejret ind i 4 sekunder, hold det i 7 sek og pust ud i 8.',
                            'Du kan finde denne og to andre øvelser til at finde ro i artiklen “Tre redskaber til ro” på appens hjemmeskærm.',
                        ]}
                        text={text}
                        setText={setText}
                    />
                ),
                5: (
                    <BlueResultBox
                        date={formatDanishDate(new Date())}
                        number={pressureLevel}
                        heading="Du har det brændende varmt"
                        description={[
                            'Du lader til at være meget presset og har brug for at komme ned i temperatur.',
                            'Prøv at spænde alle muskler i din krop i fem sekunder. Hold derefter fem sekunders pause, hvor du spænder af.',
                            'Gentag opspænding og afspænding fem gange.',
                        ]}
                        text={text}
                        setText={setText}
                    />
                ),
            }}
            default={1}
        />
    );
}
